// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ZIcJm","document":"style_document__7b9Ph","page":"style_page__3px7w","custom-width-page":"style_custom-width-page__muXRe"};